<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <base-crud :ref="'clientesApiCrud'" crudName="Clientes de API" newText="Novo cliente" :table="table"
          :columns="columns" :options="options" :endPoint="endPoint" :enableAdd="true" :enableEdit="true"
          :enableDelete="true" :enableView="false" :enableReset="false" :dataForm="dataForm">
        </base-crud>
      </div>
    </div>
  </div>
</template>

<script>
import BaseCrud from "../../layouts/Base/BaseCrud";

export default {
  data: function () {
    return {
      table: "clientesApiTable",
      columns: ["id", "nome", "webhook_url", "ativo", "actions"],
      tableData: ["id", "nome", "webhook_url", "ativo"],
      options: {
        filterByColumn: true,
        debounce: 1000,
        filterable: ["nome"],
        pagination: { chunk: 10, dropdown: false, nav: "scroll" },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          id: "ID",
          nome: "Nome",
          webhook_url: "Webhook",
          ativo: "Ativo",
          actions: "Ações",
        },
        texts: {
          filterBy: "Filtrar",
          defaultOption: "Selecione",
        },
        templates: {
          ativo: function (h, row) {
            return h("span", { class: "badge badge-light-" + (row.ativo ? "success" : "secondary") }, row.ativo ? "Sim" : "Não");
          },
        },
        requestFunction: function (data) {
          let requestData = {};

          let query = this.$parent.$parent.$parent.query(data.query);
          requestData.params = data;
          requestData.params.query = "";
          requestData.params.with = [];

          return axios.get(this.url + "?" + query, requestData).catch(
            function (e) {
              this.dispatch("error", e);
            }.bind(this)
          );
        },
      },
      endPoint: "clientes_api/",
      dataForm: {},
    };
  },
  components: {
    BaseCrud,
  },
  methods: {
    query: function (query) {
      let columns = {
        id: "id",
        nome: "nome",
      };
      let filters = "";
      $.each(query, function (index, value) {
        filters += columns[index] + "=" + value + "&";
      });
      return filters;
    },
  },
};
</script>
